import { Navigate, Route, Routes } from "react-router-dom";
import { useSelector } from "react-redux";
import { Login } from "@pages/Login";
import { CambiarContrasena } from "@pages/CambiaContrasena";
import { NuevaContrasena } from "@pages/nuevaContrasena";
import MainLayout from "../layouts/MainLayout";
import { RootState } from "@store/store";
import { CreditoSimple } from "@pages/producto/credito_simple/";
import { ProtectedRoute } from "@routes/ProtectedRoute";
import { AvisoDePrivacidad } from "@pages/AvisoDePrivacidad";
import { TerminosYcondiciones } from "@pages/TerminosYCondiciones";
import { Cotizadores } from "@pages/Cotizadores";
import { SegundoAvale } from "@pages/producto/credito_simple/second_guarantee";
import { CotizadoresPreAprobacion } from "@pages/CotizadoresPreAprobacion";
import { Components } from "@pages/Components";
import BofuCompletado from "@pages/producto/credito_simple/bofu/pm/BofuCompletado";
import RechazoVencido from "@pages/producto/credito_simple/tofu/pm/RechazoVencido";
import Rechazo from "@pages/producto/credito_simple/tofu/pm/Rechazo";
import SolicitudInactiva from "@pages/producto/credito_simple/bofu/pm/SolicitudInactiva";
import ActualizacionContrasena from "@pages/ActualizacionContrasena";
import SeleccionarMoto from "@pages/producto/credito_simple/tofu/pm/SeleccionarMoto";
import CotizadorWrapper from "@pages/producto/credito_simple/cotizador/CotizadorWrapper";

export const LenditRoute = () => {
  const appData = useSelector((state: RootState) => state.app);

  return (
    <Routes>
      <Route
        path="/producto/creditosimple/*"
        element={
          <ProtectedRoute>
            <CreditoSimple />
          </ProtectedRoute>
        }
      />

      <Route
        path="/producto/arrendamiento/*"
        element={
          <ProtectedRoute>
            <CreditoSimple />
          </ProtectedRoute>
        }
      />

      <Route
        path="/avales/*"
        element={
          <ProtectedRoute>
            <SegundoAvale />
          </ProtectedRoute>
        }
      />

      <Route path="/cambia_contraseña" element={<MainLayout />}>
        <Route index element={<CambiarContrasena />} />
      </Route>
      <Route path="/nueva_contraseña" element={<MainLayout />}>
        <Route index element={<NuevaContrasena />} />
      </Route>
      <Route path="/login" element={<MainLayout />}>
        <Route index element={<Login />} />
      </Route>
      <Route path="/actualizacion_contrasena" element={<MainLayout />}>
        <Route index element={<ActualizacionContrasena />} />
      </Route>
      <Route path="/aviso_de_privacidad" element={<MainLayout />}>
        <Route index element={<AvisoDePrivacidad />} />
      </Route>
      <Route path="/terminos_y_condiciones" element={<MainLayout />}>
        <Route index element={<TerminosYcondiciones />} />
      </Route>
      <Route path="/solicita_tu_credito" element={<MainLayout />}>
        <Route index element={<Cotizadores />} />
      </Route>
      <Route path="/solicita_tu_arrendamiento" element={<MainLayout />}>
        <Route index element={<Cotizadores type="arrendamiento" />} />
      </Route>
      <Route path="/seleccionar_moto" element={<MainLayout />}>
        <Route index element={<SeleccionarMoto />} />
      </Route>
      <Route path="/cotizador_preautorizado" element={<MainLayout />}>
        <Route index element={<CotizadoresPreAprobacion />} />
      </Route>
      <Route path="/cotizador" element={<MainLayout />}>
        <Route index element={<CotizadorWrapper />} />
      </Route>
      <Route path="/components" element={<MainLayout />}>
        <Route index element={<Components />} />
        <Route path="bofu_completado" element={<BofuCompletado />} />
        <Route path="rechazo_vencido" element={<RechazoVencido isDemo={true} />} />
        <Route path="rechazo" element={<Rechazo isDemo={true} />} />
        <Route path="solicitud_inactiva" element={<SolicitudInactiva isDemo={true} />} />
      </Route>
      <Route path="*" element={<Navigate to={appData.process_page ? appData.process_page : "/login"} />}></Route>
    </Routes>
  );
};
